export enum PersonalVoiceActionType {
  Delete = 'delete'
}
